import React, { useEffect } from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { ApiResponse } from "../../../services/api";
import Warehouse from "../../../types/warehouse";

interface WarehouseTableProps {
    rows: any[];
    columns: GridColDef[];
    height?: number;
    width?: string;
    getRowClassName?: (params: { indexRelativeToCurrentPage: number }) => string; 
    apiResponse: ApiResponse<Warehouse> | null;
    paginationModel: any; 
    setPaginationModel: any;
}

const WarehouseTable: React.FC<WarehouseTableProps> = ({
    rows,
    columns,
    height = 550,
    width = "100%",
    getRowClassName,
    apiResponse,
    paginationModel, 
    setPaginationModel,
}) => {
  useEffect(() => {
    const styleElementId = 'dynamic-row-colors';
    let styleTag = document.getElementById(styleElementId);
  
    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = styleElementId;
      document.head.appendChild(styleTag);
    }

    const uniqueColors = Array.from(new Set(
      rows.map(r => r.color).filter(c => /^([0-9A-F]{3}){1,2}$/i.test(c))
    ));

    const uniqueFontColors = Array.from(new Set(
      rows.map(r => r.fontColor).filter(c => /^([0-9A-F]{3}){1,2}$/i.test(c))
    ));
  
    styleTag.innerHTML = uniqueColors.map(color => {
      const className = `row-color-${color}`;
      return `
        .MuiDataGrid-row.${className} {
          background-color: #${color} !important;
        }
      `;
    }).join('\n');

    styleTag.innerHTML += uniqueFontColors.map(color => {
      const className = `row-font-color-${color}`;
      return `
        .MuiDataGrid-row.${className} {
          color: #${color} !important;
        }
      `;
    }).join('\n');
  }, [rows]);

  const rowHeight = 55;
  const baseHeight = 100;

  const computedHeight =
  paginationModel.pageSize <= 5
    ? paginationModel.pageSize * rowHeight + baseHeight
    : height;

  return (
    <div style={{ height: computedHeight, width }}> 
      <DataGrid
        rows={rows}
        columns={columns}
        pageSizeOptions={[5, 10, 20, 100]}
        pagination
        checkboxSelection={false}
        getRowClassName={getRowClassName}
        paginationMode='server'
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        rowCount={apiResponse?.data?.totalItems ?? 0}
        disableRowSelectionOnClick
        sx={{
          "& .MuiDataGrid-row:nth-of-type(even)": {
            backgroundColor: "#f5f5f5",
          },
          "& .MuiDataGrid-row:nth-of-type(odd)": {
            backgroundColor: "white",
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: "#b2d1ff",
        },
        "& .MuiTablePagination-selectLabel": {
          marginTop: "14px",
        },
        "& .MuiTablePagination-displayedRows": {
          marginTop: "14px",
        },
        "& .MuiDataGrid-cell[id='id']": {
          cursor: 'pointer !important',
        },
        "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
          outline: "none",
        },
        "& .MuiDataGrid-row:focus, & .MuiDataGrid-row:focus-within": {
          outline: "none",
        }
        }}
      />
    </div>
  );
};

export default WarehouseTable;
